<template>
<div>
<div id="kv">
  <h1>アカウント登録</h1>
</div>
<main>
  <section class="content page_form">
    <div class="container">
      <div class="ttl">
        <p class="txt_l mb10">入力されたメールアドレスに<br class="sp">確認用メールをお送りします。</p>
        <p class="txt_red">*は必須入力項目です。 </p>
      </div>
      <form class="formWrap">
<ValidationObserver ref="observer" v-slot="{valid}">
        <div class="item_form">
          <div class="ttl_form">
            <label for="name01">お名前<span>*</span></label>
          </div>
          <div class="part_form">
            <div class="col2">
<ValidationProvider name="name01" rules="name01-required|name01-period" v-slot="{ errors }" mode="lazy" slim>
              <input type="text" name="name01" id="name01" placeholder="姓" v-model="form.name01">
</ValidationProvider>
<ValidationProvider name="name02" rules="name02-required|name02-period" v-slot="{ errors }" mode="lazy" slim>
              <input type="text" name="name02" id="name02" placeholder="名" v-model="form.name02">
</ValidationProvider>
            </div>
            <div class="txt_error" v-if="$refs['observer'] && $refs['observer']['flags']['invalid'] && $refs['observer'] && ($refs['observer']['errors']['name01'][0] || $refs['observer']['errors']['name02'][0])">
              <p v-if="$refs['observer']['errors']['name01'][0]">{{ $refs['observer']['errors']['name01'][0] }}</p>
              <p v-else-if="$refs['observer']['errors']['name02'][0]">{{ $refs['observer']['errors']['name02'][0] }}</p>
            </div>
          </div>
        </div>
        <div class="item_form">
          <div class="ttl_form">
            <label for="kana01">ふりがな<span>*</span></label>
          </div>
          <div class="part_form">
            <div class="col2">
<ValidationProvider name="kana01" rules="kana01-required|kana01-hiragana" v-slot="{ errors }" mode="lazy" slim>
              <input type="text" name="kana01" id="kana01" placeholder="せい" v-model="form.kana01">
</ValidationProvider>
<ValidationProvider name="kana02" rules="kana02-required|kana02-hiragana" v-slot="{ errors }" mode="lazy" slim>
              <input type="text" name="kana02" id="kana02" placeholder="めい" ref="kana02" v-model="form.kana02">
</ValidationProvider>
            </div>
            <div class="txt_error" v-if="$refs['observer'] && $refs['observer']['flags']['invalid'] && $refs['observer'] && ($refs['observer']['errors']['kana01'][0] || $refs['observer']['errors']['kana02'][0])">
              <p v-if="$refs['observer']['errors']['kana01'][0]">{{ $refs['observer']['errors']['kana01'][0] }}</p>
              <p v-else-if="$refs['observer']['errors']['kana02'][0]">{{ $refs['observer']['errors']['kana02'][0] }}</p>
            </div>
          </div>
        </div>
        <div class="item_form">
          <div class="ttl_form">
            <label for="email01">メールアドレス<span>*</span></label>
          </div>
          <div class="part_form">
<ValidationProvider name="email" rules="email-required|email-email|email-exists" v-slot="{ errors }" mode="lazy" slim>
            <input type="text" name="email" id="メールアドレス" placeholder="example@majesty-golf.com" v-model="form.email" @click="emptyEmailErrorMessage()" @blur="processSubValidatedEmail()">
</ValidationProvider>
            <div class="txt_error" v-if="$refs['observer'] && $refs['observer']['flags']['invalid'] && $refs['observer'] && $refs['observer']['errors']['email'][0]">
              <p>{{ $refs['observer']['errors']['email'][0] }}</p>
            </div>
            <div class="txt_error" v-if="emailErrorMessage">
              <p>{{ emailErrorMessage }}</p>
            </div>
          </div>
        </div>
<ul class="txt_s list_caution">
			<li>※携帯メールアドレス（docomo/au/softbankのキャリアメール）でメール防止フィルターをご利用の場合は、【majesty_ownersclub@majesty-golf.com】を受信できるよう設定をお願いいたします。</li>
			<li>※YahooメールやGmailなどフリーメールの場合は、迷惑メールやゴミ箱に自動的に振り分けられている可能性がありますので、ご確認頂きますようお願いいたします。</li>
			</ul>
        <div class="flexnone">
          <div class="btnArea">
            <div class="btnSubmit">
              <button type="button" class="arrow" @click="submit">確認用メールを送る</button>
            </div>
          </div>
          <p>※ご登録いただきましたメールアドレスに<br class="sp">確認のメールをお送りします。</p>
        </div>
</ValidationObserver>
      </form>
    </div>
  </section>
</main>
</div>
</template>

<script>
import { extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import Axios from 'axios'
import Validate from '../validate'
import String from '../string'

extend('name01-required', {
  ...required,
  message: 'お名前を入力してください。'
})

extend('name01-period', {
  validate: Validate.methods.validatePeriod,
  message: 'お名前を正しく入力してください。'
})

extend('name02-required', {
  ...required,
  message: 'お名前を入力してください。'
})

extend('name02-period', {
  validate: Validate.methods.validatePeriod,
  message: 'お名前を正しく入力してください。'
})

extend('kana01-required', {
  ...required,
  message: 'ふりがなを入力してください。'
})

extend('kana01-hiragana', {
  validate: Validate.methods.validateHiragana2,
  message: 'お名前をひらがなで入力してください。'
})

extend('kana02-required', {
  ...required,
  message: 'ふりがなを入力してください。'
})

extend('kana02-hiragana', {
  validate: Validate.methods.validateHiragana2,
  message: 'お名前をひらがなで入力してください。'
})

extend('kana01-exists-full', {
  params: ['kana02'],
  validate: function (value, { kana02 }) {
      return true
  },
  message: 'お名前を。'
})

extend('kana02-exists-full', {
  validate: function (value) {
    return false
  },
  message: 'お名前をひらがなで入力してください。'
})

extend('kana02-hiragana', {
  validate: Validate.methods.validateHiragana2,
  message: 'お名前をひらがなで入力してください。'
})

extend('email-required', {
  ...required,
  message: 'メールアドレスを入力してください。'
})

extend('email-email', {
  ...email,
  message: '正しい形式で入力してください。' 
})

extend('email-exists', {
  params: ['id'],
  validate: async (value) => {
    return await Axios.get('/api/exists_owner_email', {
      params: {
        email: value
      }
    })
    .then((res) => {
      if (res.data.results == 'exists') {
        return false
      }
      else {
        return true
      }
    })
  },
  message: 'このメールアドレスは既に登録されております。ログインにお進みください。'
})

export default {
  data: function () {
    return {
      form: {
        name01: '',
        name02: '',
        kana01: '',
        kana02: '',
        email: ''
      },
      emailErrorMessage: ''
    }
  },
  mixins: [String],
  methods: {
    submit: function () {
      this.$refs.observer.validate()
        .then((res) => {
          if (res) {
            this.$root.$children[0].$set(this.$root.$children[0].$data, 'isLoading', true)

            let postData = {
              name01: this.form.name01,
              name02: this.form.name02,
              kana01: this.form.kana01,
              kana02: this.form.kana02,
              email: this.form.email
            }

            Axios.post('/api/owner_registration_email', postData)
              .then((res) => {
                if (res.data.status == 'success') {
                  this.$root.$children[0].$set(this.$root.$children[0].$data.form, 'email', this.form.email)
                  this.$root.$children[0].$set(this.$root.$children[0].$data, 'currentView', 'RegistrationEmailThanks')
                  this.$root.$children[0].$set(this.$root.$children[0].$data, 'isLoading', false)
                }
              })
          }
          else {
            this.$root.$children[0].$set(this.$root.$children[0].$data, 'isLoading', false)
          }
        }
      )
    },
    emptyEmailErrorMessage: function () {
      this.$set(this.$data, 'emailErrorMessage', '')
    },
    processSubValidatedEmail: function () {
      this.$set(this.$data.form, 'email', this.subValidatedEmail(this.form.email))
    }
  }
}
</script>
